import { render } from "./property-desc.vue?vue&type=template&id=251e01db"
import script from "./property-desc.js?vue&type=script&lang=js"
export * from "./property-desc.js?vue&type=script&lang=js"

import "./property-desc.vue?vue&type=style&index=0&id=251e01db&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__